// extracted by mini-css-extract-plugin
export default {"viewmsg":"ViewPracticeMessagesInt_viewmsg__j+dt1","title":"ViewPracticeMessagesInt_title__-auKL","content":"ViewPracticeMessagesInt_content__YZhPs"};